import React, {useEffect} from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

export default function Learn({ checkAuth, course }) {


  return (
    <StyledLearn className="learn_section">
      <div className="container">
        <div className="learn learn_page">
          <div className="learn_row row">
            <div className="col-8">
              <div className="learn_badge">Бесплатный курс</div>
              <div className="display-5 fw-bold mb-2">{course ? course.course.content : ''}</div>
              {/*<p className="learn_lead col-md-10">*/}
              {/*  {course ? course.course.content : ''}*/}
              {/*</p>*/}
              <div className="learn_stats">
                <span className="learn_stats_item me-4">
                  <span className="bi bi-clock me-2"></span> {course ? course.course.timeComplete : ''} часов
                </span>
                <span className="learn_stats_item me-4">
                  <span className="bi bi-people me-2"></span> 35197* студентов
                </span>
                <span className="learn_stats_item me-4">
                  <span className="bi bi-book me-2"></span> {course ? course.categoryCourse[0].leasons.length : ''} урок с практикой
                  в браузере
                </span>
              </div>
              <Link to="#" className="learn_btn fw-400" onClick={checkAuth}>
                Начать обучение
              </Link>
            </div>

            <div className="col-4 text-center">
              <span className="colored x-fs-15 devicon-html5-plain"></span>
            </div>
          </div>
        </div>
      </div>
    </StyledLearn>
  );
}

const StyledLearn = styled.section`
  .learn {
    padding: 3rem;
    display: flex;
    box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 15%);
    border-radius: 0.3rem;
    position: relative;
    overflow: hidden;
    background: rgba(255, 255, 255, 1);
  }

  .learn_badge {
    display: inline-block;
    padding: 0.35em 0.65em;
    font-size: 0.75em;
    font-weight: 700;
    line-height: 1;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25rem;
    border: 1px solid #dee2e6;
    color: rgba(33, 37, 41, 1);
  }

  .learn_lead {
    font-size: 1.25rem;
    font-weight: 300;
    line-height: 1.5;
    margin-bottom: 1rem;
  }

  .learn .learn_lead {
    font-weight: 400;
  }
  .learn_btn {
    color: #fff;
    background-color: #0d6efd;
    border-color: #0d6efd;
    padding: 0.5rem 1.5rem;
    font-size: 1.25rem;
    border-radius: 0.3rem;
    font-weight: 700;
    display: inline-block;
    line-height: 1.5;
    cursor: pointer;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    margin-bottom: 1rem;
  }
  .learn_btn:hover {
    color: #fff;
    background-color: #0b5ed7;
    border-color: #0a58ca;
  }

  .learn_stats_item {
    display: flex;
    align-items: center;
    font-size: 1.25rem;
    font-weight: 300;
    color: #6c757d;
  }
  .learn_stats {
    display: flex;
    align-items: center;
    margin-bottom: 48px;
  }
  .learn_row.row {
    display: flex;
    align-items: center;
    width: 100%;
  }
  .learn_page.learn {
    border: 1px solid #dee2e6;
    box-shadow: 0 0.125rem 0.25rem rgb(0 0 0 / 8%);
  }

  @media (max-width: 1191px) {
    .learn_stats {
      flex-wrap: wrap;
    }
  }

  @media (max-width: 567px) {
    .learn_btn {
      width: 100%;
      text-align: center;
    }

    .learn.learn_page .learn_btn {
      width: auto;
    }

    .learn_row.row {
      & > div.col-4 {
        display: none;
      }
    }
  }
`;
